import digitalAssetsAssetCard from "components/jiffy/digital-assets/digital-assets-asset-card/digital-assets-asset-card";
import digitalAssetsAssetCardSearchScore from "components/jiffy/digital-assets/digital-assets-asset-card-search-score/digital-assets-asset-card-search-score";
import digitalAssetsImagesPreview from "components/jiffy/digital-assets/digital-assets-images-preview/digital-assets-images-preview";

export default () => {
  digitalAssetsAssetCard();
  digitalAssetsImagesPreview().init();
  digitalAssetsAssetCardSearchScore();
};
